import "./project.css"
import personone from "../../img/p1.png"
import persontwo from "../../img/p2.png"
import personthree from "../../img/p3.png"
import personfour from "../../img/p4.png"
import personfive from "../../img/p5.png"
import personsix from "../../img/p6.png"
function Projeectt(){
    return(
        <>
        <div className="projectt">
            <div className="start">
                <h4>Projects</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
                 <div className="table">
                       
                        <div className="end">
                            <table className="table table-hover  rounded align-middle">
                <thead> 
                  <tr>
                    <th>Checkbox</th>
                    <th>Project Name</th>
                    <th>customers</th>
                          <th>Info</th>
            
                    <th>Proposal</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                        <input type="checkbox" name="" id="" />
                    </td>
                    <td>
                        <i class="fa-brands fa-github"></i> Online Examntion System
                    </td>
                    <td>
                      <img src={personone} alt="" />
                    </td>
                    <td>
                      <p>Archie Cantones</p>
                      <p>ariceh.tones@gmail.com</p>
                    </td>
                    <td>Sent</td>
                    <td>7/06/2023 10:53</td>
                    <td>7/06/2024 10:53</td>

                    <td>Compelted</td>
                    <td>    <i class="fa-solid fa-eye"></i>    <i className="fa-solid fa-ellipsis-vertical"></i>
            </td>
            
                  </tr>
                 <tr>
                     <td>
                        <input type="checkbox" name="" id="" />
                    </td>
                    <td>
                        <i class="fa-brands fa-github"></i> Online Examntion System
                    </td>
                    <td>                      <img src={persontwo} alt="" />
</td>
                      
                    <td>
                      <p>Holmes Cherryman</p>
                      <p>cherryman @gmail.com</p>
                    </td>
                    <td>New</td>
                    <td>11/06/2023 10:53</td>
                    <td>11/06/2024 10:53</td>

                    <td>In Progress</td>
                    <td>  <i class="fa-solid fa-eye"></i>      <i className="fa-solid fa-ellipsis-vertical"></i>
            </td>
            
                  </tr>
                   <tr>
                     <td>
                        <input type="checkbox" name="" id="" />
                    </td>
                    <td>
<td>
                        <i class="fa-brands fa-github"></i> Weather Applcation
                    </td>
                    </td>
                    <td>
                      <img src={personthree} alt="" />
                    </td>
                    <td>
                      <p>Malanie Hanvey</p>
                      <p>malan-hanvey@gmail.com</p>
                    </td>
                    <td>Sent </td>
                    <td>1/06/2023 10:53</td>
                    <td>1/06/2024 10:53</td>

                    <td>Compelted</td>
                    <td>  <i class="fa-solid fa-eye"></i>      <i className="fa-solid fa-ellipsis-vertical"></i>
            </td>
            
                  </tr>
                  <tr>
                     <td>
                        <input type="checkbox" name="" id="" />
                    </td>
                    <td>
                                             <i class="fa-brands fa-github"></i> Personal Portfilo

                    </td>
                    <td>
                      <img src={personfour} alt="" />
                    </td>
                    <td>
                      <p>Kenneth Hune</p>
                      <p>nneth.une@gmail.com</p>
                    </td>
                    <td>Returnning</td>
                    <td>5/06/2023 10:53</td>
                     <td>5/06/2024 10:53</td>

                    <td>Not Intersted</td>
                    <td>  <i class="fa-solid fa-eye"></i>      <i className="fa-solid fa-ellipsis-vertical"></i>
            </td>
            
                  </tr>
                    <tr>
                         <td>
                        <input type="checkbox" name="" id="" />
                    </td>
                    <td>
                                             <i class="fa-brands fa-github"></i> Admin Dashbaord

                    </td>
                    <td>
                      <img src={personfive} alt="" />
                    </td>
                    <td>
                      <p>Kennth Hune </p>
                      <p>nneth.une@gmail.com</p>
                    </td>
                    <td>Returnning</td>
                    <td>3/06/2023 10:53</td>
                    <td>3/06/2024 10:53</td>

                    <td>Not Intersted</td>
                    <td>   <i class="fa-solid fa-eye"></i>     <i className="fa-solid fa-ellipsis-vertical"></i>
            </td>
            
                  </tr>
                  
                 
                 
                </tbody>
              </table>
                        </div>
                    </div>
        </div>
        </>
    )
}
export default  Projeectt